// frontend-shell-standard.md step 1: Vuetify styles, then NATCA tokens.
import 'vuetify/styles'
import '@natca-itc/ui-shell/tokens'
import '@natca-itc/ui-shell/shell-styles'
import '@mdi/font/css/materialdesignicons.css'
import './style.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import { natcaVuetifyTheme, natcaDefaults } from '@natca-itc/ui-shell'
import App from './App.vue'
import { router } from './router'
import { installAuth } from './lib/auth'

const app = createApp(App)
app.use(createPinia())
app.use(createVuetify({ theme: natcaVuetifyTheme, defaults: natcaDefaults }))
installAuth(app)
app.use(router)
app.mount('#app')


// PWA: installable to a home screen. Production only, so Vite's dev server and
// HMR never sit behind a cache.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => { /* the app works without it */ }) })
}
